import deleteReducer from 'reducers/entity/delete';
import { combineReducers } from 'redux-immutable';

export default combineReducers({ delete: deleteReducer });
